import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'

import StepType from './StepType'
import {
  message,
  Card,
  Table,
  Divider,
  Popconfirm,
  Button,
  Input,
  Tabs,
  Col,
  Icon,
  Avatar,
  Tooltip
} from 'antd'

import { useDeepEffect } from '../../utils/hooks'
import _ from 'lodash'
import axios from 'axios'
import Highlighter from 'react-highlight-words'
import WrappedStepForm from './components/StepForm'
import {
  getStep,
  createStep,
  updateStep,
  deleteStep,
} from '../../modules/step'

const Preset = () => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [searchText, setSearchText] = useState('')
  const [stepType, setStepType] = useState([])


  const { step, isLoading } = useSelector(
    (state) => ({
      step: state.step.step,
      isLoading: state.step.isLoading
    }),
    []
  )
  useDeepEffect(() => {
    async function fetch() {
      await dispatch(getStep())
    }
    fetchStepType()
    fetch()
  }, [])

  async function fetchStepType() {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/step/stepType`
      )
      setStepType(res.data)
    } catch (err) {
      console.log(err)
    }
  }

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }
  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }

  const onCloseModal = async () => {
    await setVisible(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updateStep(data))
    } else {
      await dispatch(createStep(data))
    }

    await dispatch(getStep())
    await setVisible(false)
    await setFormData({})
  }

  const onDelete = async (id) => {
    await dispatch(deleteStep(id))
    await dispatch(getStep())
  }

  const refetchData = async () => { }

  const columns = [
    {
      title: 'Step',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name'),
      render: (name, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      render: (text, record) => (
        <div>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}
          >
            <Button
              type="danger"
              size="small"
              shape="circle"
              icon="delete"
            />
          </Popconfirm>
        </div>
      )
    }
  ]
  return (
    <div>
      <Card
        title="Step"
        extra={
          <div>
            <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
              New Step
            </Button>
            <Button size="small" icon="reload" onClick={() => refetchData()}>
              Reload
            </Button>
          </div>
        }
      >
        <Tabs type="card" defaultActiveKey="0">
          {step &&
            step.map((stepType, index) => (
              <Tabs.TabPane tab={stepType.stepTypeName} key={index}>
                <Table
                  loading={isLoading}
                  dataSource={stepType.stepList}
                  columns={columns}
                />
              </Tabs.TabPane>
            ))}
        </Tabs>

        <WrappedStepForm
          visible={visible}
          onOk={onOk}
          onCancel={onCloseModal}
          formData={formData}
          stepType={stepType}
        />
      </Card>
      <br></br>
      <StepType />
    </div>
  )
}
export default compose(
  withApollo
)(Preset)
